<template>
  <div class="app-container">
    <div class="content">
      <el-form :model="form" :rules="rules" ref="form" label-width="150px">
        <div class="extra">
          <input type="text" name="hidden1" />
          <input type="password" name="hidden2" />
          <div></div>
        </div>
        <el-form-item label="用户名：">
          {{ form.loginName }}
        </el-form-item>
        <el-form-item label="员工姓名：" prop="name">
          <el-input v-model="form.name" maxlength="15" placeholder="请输入员工姓名，长度不能大于15个字符"></el-input>
        </el-form-item>
        <el-form-item label="员工编号：">
          <el-input v-model="form.staffCode" placeholder="请输入至少五个字符"></el-input>
        </el-form-item>
        <el-form-item label="手机：" :class="{ 'is-error': errorPhone }">
          <el-input v-model="form.mobile" placeholder="请输入手机号" @blur="validateTel(form.mobile)"> </el-input>
          <div v-show="errorPhone" class="el-form-item__error">{{ phoneText }}</div>
        </el-form-item>
        <el-form-item label="邮箱：" :class="{ 'is-error': errorEmail }">
          <el-input v-model="form.email" placeholder="请输入邮箱地址" @blur="validateEmail(form.email)"> </el-input>
          <div v-show="errorEmail" class="el-form-item__error">{{ emailText }}</div>
        </el-form-item>
        <!-- <el-form-item label="用户组：" prop="ugid">
        <el-select v-model="form.ugid" clearable placeholder="请选择">
          <el-option v-for="item in grpoptions" :key="item.ugid" :label="item.ugname" :value="item.ugid">
          </el-option>
        </el-select>
      </el-form-item> -->
        <el-form-item label="角色：" prop="roles">
          <div class="role-box" @click="openDialog">
            <div class="role-detail" id="roleContent" v-text="allRoleText()" placeholder="请选择"></div>
            <span
              class="el-select__caret el-input__icon el-icon-arrow-down"
              :class="{ 'is-reverse': roleDialog }"
            ></span>
          </div>
        </el-form-item>
        <el-form-item label="组织权限：" prop="orgAuth">
          <div class="session1" ref="shopBox">
            <div class="shop-content" @click="showTree">
              <ul class="shop-name">
                <li v-for="(item, index) in checkNodes" :key="index">
                  {{ item.name }}<i class="icon-delete" @click.stop="deleteNode(item)">×</i>
                </li>
              </ul>
              <span
                class="el-select__caret el-input__icon el-icon-arrow-down"
                :class="{ 'is-reverse': treeIsShow }"
              ></span>
              <!-- <div v-show="errorOrg" class="el-form-item__error">请选择</div> -->
            </div>
            <div class="treeBox mb20" v-show="treeIsShow"> 
              <div class="tree-content">
                <el-input placeholder="请输入客户组织名称" v-model="filterText"> </el-input>
                <el-tree
                  node-key="orgcode"
                  :data="shopsTree"
                  :props="defaultProps"
                  :default-expanded-keys="orgcode"
                  ref="tree"
                  :filter-node-method="filterNode"
                  :expand-on-click-node="false"
                  :highlight-current="true"
                  show-checkbox
                >
                </el-tree>
              </div>
              <div class="dialog-btn borderTop">
                <button @click="getOrgcode" type="button" class="ml20 ag-model-btn blue fts mr5">确定</button>
                <button @click="hideAll" type="button" class="ag-model-btn gray fts">取消</button>
              </div>
            </div>
          </div>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitForm('form')">完成</el-button>
          <el-button @click="() => this.$router.go(-1)">取消</el-button>
        </el-form-item>
      </el-form>

      <el-dialog title="角色管理" :visible.sync="roleDialog" width="531px" :before-close="handleClose">
        <div class="">
          <div class="role-left">
            <div v-for="(item, index) in roleList" v-show="!item.addRight">
              <div class="checktitle">新零售-{{ item.pname }}</div>
              <el-radio
                class="rediocontain"
                v-model="item.radioValue"
                v-for="(ele, key) in item.roleList"
                :label="ele.rid"
                >{{ ele.rname }}
              </el-radio>
            </div>
          </div>
          <div class="transfer">
            <el-button @click="addRole" :disabled="addBtn">添加 ></el-button>
            <el-button @click="cancelSelect" :disabled="!selectList.length"> 取消</el-button>
          </div>
          <div class="role-right">
            <div v-for="(item, index) in roleList" v-show="item.addRight">
              <div class="checktitle">新零售-{{ item.pname }}</div>
              <el-radio class="rediocontain" v-model="selectList[index]" :label="item.pid"
                ><span v-text="selectName(item)"></span>
              </el-radio>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="roleDialog = false">取 消</el-button>
          <el-button type="primary" @click="submitRole">提 交</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { orgShopTree, getEnableUserGroupList, getUsercpInfo, updateUser, getPlatRoles } from 'src/api/legacy'
// onload = () => {
//   roleContent.onmouseover = function () {
//     this.title = this.innerText
//   }
// }

export default {
  data() {
    var validateOrgAuth = (rule, value, callback) => {
      if (!this.orgcode.length) {
        callback(new Error('请选择'))
      } else {
        callback()
      }
    }
    return {
      treeIsShow: false, //树显示
      checkNodes: [], //默认组织树名
      getTreeOrgcode: [], //选中树组织数据
      shopsTree: [],
      defaultProps: {
        label: 'name',
        children: 'sublist',
      },
      form: {
        loginName: '',
        name: '',
        staffCode: '',
        mobile: '',
        email: '',
        password: '',
        ugid: '',
        roles: '',
      },
      grpoptions: [],
      filterText: '',
      uid: '',
      rules: {
        name: [
          {
            required: true,
            message: '不能为空',
            trigger: 'blur',
          },
        ],
        roles: [
          {
            required: true,
            message: '请选择',
            trigger: 'click',
          },
        ],
        orgAuth: [
          {
            required: true,
            validator: validateOrgAuth,
            trigger: 'change',
          },
        ],
      },
      errorOrg: false,
      roleList: [], //源数据
      PlatroleList: [],
      selectList: [],
      roleDialog: false,
      errorPhone: false,
      phoneText: '',
      errorEmail: false,
      emailText: '',
    }
  },
  methods: {
    validateTel(val, text) {
      if ((this.errorEmail && val === '') || (this.form.email && !this.errorEmail)) {
        this.errorPhone = false
        return true
      }
      if (val === '') {
        this.errorPhone = true
        this.phoneText = '请输入正确的手机号'
        return false
      } else if (!/^[1][3,4,5,7,8,9][0-9]{9}$/.test(val)) {
        this.errorPhone = true
        this.phoneText = '请输入正确的手机号'
        return false
      } else {
        this.errorPhone = false
        if (this.form.email === '') {
          this.errorEmail = false
        }
        return true
      }
    },
    validateEmail(val) {
      if (this.form.regType !== 2) return
      if (val === '') {
        this.errorEmail = true
        this.emailText = '不能为空'
        return false
      } else if (!/^([0-9A-Za-z\-_\.]+)@([0-9a-z]+\.[a-z]{2,5}(\.[a-z]{2})?)$/.test(val)) {
        this.errorEmail = true
        this.emailText = '请输入正确的邮箱格式'
        return false
      } else {
        //校验手机号重复性
        this.errorEmail = false
        return true
      }
    },
    validateOrg(val, text) {
      if (!this.orgcode.length) {
        this.errorOrg = true
        return false
      } else {
        this.errorOrg = false
        return true
      }
    },
    OrgShopTree() {
      //获取树文件数据
      return orgShopTree().then((res) => {
        if (res.data && res.status === 0) {
          res.data.disabled = false
          this.shopsTree = [res.data]
        }
      })
    },
    hideAll() {
      //隐藏树组织
      this.treeIsShow = false
    },
    treeClick() {
      //显示树组织
      this.filterText = ''
      this.$refs.tree.setCheckedNodes(this.checkNodes)
      this.treeIsShow = true
    },
    showTree() {
      this.treeClick()
    },
    filterNode(value, data, node) {
      // 如果什么都没填就直接返回
      if (!value) return true
      // 如果传入的value和data中的label相同说明是匹配到了
      const reg = new RegExp(value, 'i')
      if (reg.test(data.name)) {
        return true
      }
      // 否则要去判断它是不是选中节点的子节点
      return this.checkBelongToChooseNode(value, data, node)
    },
    // 判断传入的节点是不是选中节点的子节点
    checkBelongToChooseNode(value, data, node) {
      const level = node.level
      // 如果传入的节点本身就是一级节点就不用校验了
      if (level === 1) {
        return false
      }
      // 先取当前节点的父节点
      let parentData = node.parent
      // 遍历当前节点的父节点
      let index = 0
      while (index < level - 1) {
        // 如果匹配到直接返回
        if (parentData.data.name.indexOf(value) !== -1) {
          return true
        }
        // 否则的话再往上一层做匹配
        parentData = parentData.parent
        index++
      }
      // 没匹配到返回false
      return false
    },
    getOrgcode() {
      const nodes = this.$refs.tree.getCheckedNodes()
      this.checkNodes = this.filter(nodes)
      this.treeIsShow = false
      this.validateOrg()
    },
    filter(checkNodes) {
      const orgcodeArr = checkNodes.map((n) => n.orgcode)
      const index = orgcodeArr.findIndex((item) => item === '0')
      orgcodeArr.splice(index, 1)
      return checkNodes.filter((v) => !orgcodeArr.includes(v.parentCode))
    },
    deleteNode(node) {
      const index = this.checkNodes.findIndex((v) => {
        return node === v
      })
      this.checkNodes.splice(index, 1)
      this.$refs.tree.setCheckedNodes(this.checkNodes)
      this.validateOrg()
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        this.validateOrg()
        if (valid) {
          if (this.validateTel(this.form.mobile) || this.validateEmail(this.form.email)) {
            this.updateUser()
          }
        }
      })
    },
    getEnableUserGroupList() {
      //查询用户组
      getEnableUserGroupList().then((res) => {
        if (res && res.status === 0) {
          this.grpoptions = res.data
        }
      })
    },
    async getUsercpInfo() {
      //查询
      await this.getRoleList()
      await this.OrgShopTree()
      await this.getEnableUserGroupList()
      getUsercpInfo({
        uid: this.uid,
      }).then((res) => {
        if (res && res.status === 0) {
          this.form.ugid = res.data.ugid === 0 ? '' : res.data.ugid
          this.form.email = res.data.email
          this.form.loginName = res.data.loginName
          this.form.mobile = res.data.mobile
          this.form.name = res.data.name
          this.form.staffCode = res.data.staffCode
          //绑定用户
          const roleIds = res.data.roles
          this.setRoleList(roleIds)
          //组织权限
          res.data.orgNames.forEach((v) => {
            this.checkNodes.push({
              name: v,
            })
          })
          this.$refs.tree.setCheckedKeys(res.data.orgs)
          const nodes = this.$refs.tree.getCheckedNodes()
          this.checkNodes = this.filter(nodes)
        }
      })
    },
    setRoleList(roleIds) {
      const list = JSON.parse(JSON.stringify(this.roleList))
      list.forEach((v) => {
        return v.roleList.map((e, index) => {
          if (roleIds.includes(e.rid)) {
            v.radioValue = e.rid
            v.addRight = true
          }
        })
      })
      setTimeout(() => {
        this.form.roles = [
          ...list.filter((v) => {
            return v.radioValue && v.addRight === true
          }),
        ]
      })
    },
    updateUser() {
      //修改
      let orgs = this.orgcode.filter((item) => item !== '0')
      this.form.ugid = this.form.ugid === '' ? 0 : this.form.ugid
      let params = {
        uid: this.uid,
        name: this.form.name,
        staffCode: this.form.staffCode,
        mobile: this.form.mobile,
        email: this.form.email,
        roles: this.form.roles.map((v) => v.radioValue),
        orgs,
        ugid: this.form.ugid,
      }
      updateUser(params).then((res) => {
        if (res.data) {
          this.$message({
            message: '成功',
            type: 'success',
          })
          this.$router.push({ name: 'userTable', query: { value: this.form.loginName } })
        } else {
          this.$message({
            message: '失败',
            type: 'success',
          })
        }
      })
    },
    getRoleList() {
      //查询各平台角色
      getPlatRoles().then((res) => {
        if (res && res.status === 0) {
          if (res.status == 0) {
            this.roleList = res.data.map((v) => {
              return {
                ...v,
                radioValue: '',
                addRight: false,
              }
            })
          }
        }
      })
    },
    addRole() {
      //添加
      this.roleList.forEach((item) => {
        if (item.radioValue) {
          item.addRight = true
        }
      })
    },
    cancelSelect() {
      //取消
      this.roleList.forEach((item) => {
        if (this.selectList.includes(item.pid)) {
          item.addRight = false
          item.radioValue = ''
        }
      })
      this.selectList = []
    },
    selectName(item) {
      if (item.radioValue) {
        return item.roleList.find((v) => {
          return v.rid === item.radioValue
        }).rname
      }
    },
    submitRole() {
      this.roleDialog = false
      let list = JSON.parse(JSON.stringify(this.roleList))
      this.form.roles = list.filter((v) => {
        return v.radioValue && v.addRight === true
      })
      //校验
      if (this.form.roles.length) {
        $('.role-box+.el-form-item__error').hide()
      } else {
        $('.role-box+.el-form-item__error').show()
      }
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then((_) => {
          done()
        })
        .catch((_) => {})
    },
    openDialog() {
      this.roleDialog = true
      const roleIds = this.form.roles.map((v) => v.radioValue)
      console.log(this.form.roles, this.roleList, roleIds)

      this.form.roles.length &&
        this.form.roles.forEach((v) => {
          const i = this.roleList.findIndex((r) => r.pid === v.pid)
          this.roleList[i].radioValue = v.radioValue
          this.roleList[i].addRight = true
        })
    },
    allRoleText() {
      return (
        this.form.roles && this.form.roles.map((v) => (v.pname ? `${v.pname}： ${this.selectName(v)}` : '')).join('、')
      )
    },
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val)
    }
  },
  computed: {
    orgcode() {
      return this.checkNodes.length ? this.checkNodes.map((v) => v.orgcode) : []
    },
    addBtn() {
      return this.roleList.every((item) => {
        return item.radioValue === '' || item.addRight
      })
    },
  },
  created() {},
  mounted() {
    this.uid = this.$route.query.id
    this.getUsercpInfo()
    document.addEventListener('click', (e) => {
      if (!this.$refs.shopBox.contains(e.target)) {
        this.treeIsShow = false
      }
    })
  },
}
</script>

<style lang="less" scoped>
* {
  box-sizing: border-box;
}

.el-select .el-input .el-input__inner,
.el-input__inner {
  height: 36px;
  line-height: 36px;
}

.containerX .contentX {
  padding-left: 0;
  padding-right: 0;
}

.navtitle {
  width: 100%;
  height: 80px;
  line-height: 80px;
  border-bottom: 1px solid #d1d1d1;
  padding: 0px 20px;
  font-size: 14px;
}

.content {
  padding-top: 40px;
  font-size: 12px;
  padding-left: 100px;
}

.el-input {
  width: 468px;
}

.detail.el-form-item.is-required .el-form-item__label:before {
  content: '';
}

.psdbox {
  width: 468px;
  position: relative;
}

.extra {
  position: relative;
}

.extra div {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: #fff;
}

/* 组织权限 */
.session1 {
  /* padding:20px 20px 0 20px;
  margin: 0 -20px;
  align-items: center; */
}

.el-tree {
  max-height: 268px;
  overflow-y: auto;
  padding: 0 20px;
  width: 90%;
}

.session1 .shop-content {
  /* margin-top: 5px; */
  position: relative;
  width: 468px;
}

.shop-content .shop-name {
  width: 468px;
  min-height: 36px;
  line-height: 36px;
  padding: 0px 24px 0px 10px;
  box-sizing: border-box;
  border: 1px solid #dcdfe6;
  font-size: 12px;
  border-radius: 4px;
  cursor: pointer;
}

.shop-content .shop-name:hover,
.shop-content .shop-name:focus {
  border-color: #c0c4cc;
}

.session1 .disabled-input {
  background-color: #f5f7fa;
  border-color: #e4e7ed;
  color: #c0c4cc;
  cursor: not-allowed;
}

.shop-content .disabled-input:hover,
.shop-content .disabled-input:focus {
  border-color: #dcdfe6;
}

.el-form-item.is-error .shop-name {
  border-color: #f56c6c;
}

.shop-name li {
  height: 22px;
  line-height: 22px;
  padding: 0 20px 0 8px;
  display: inline-block;
  background-color: #fff;
  margin-right: 8px;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
  position: relative;
}

li .icon-delete {
  position: absolute;
  right: 0;
  padding: 0 8px 0 10px;
}

.treeBox {
  width: 468px;
  left: 0;
  top: auto;
  margin-top: 10px;
}

.shop-content .el-icon-arrow-down,
.role-box .el-icon-arrow-down {
  color: #c0c4cc;
  position: absolute;
  top: 0px;
  right: 6px;
}

.is-reverse {
  transform: rotate(180deg);
}

.session1 .treeBox {
  left: 0;
}

.tree-content .el-input {
  padding: 16px 24px;
}

.dialog-btn {
  padding: 10px;
}

.required .el-form-item__label:before {
  content: '*';
  color: #f56c6c;
  margin-right: 4px;
}
</style>